import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 40, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 1, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const Chapter = ({ number, label, dark = false }) => (
  <div className="flex items-center gap-4 mb-8" data-testid={`chapter-${number}`}>
    <span className={`font-serif italic text-lg ${dark ? "text-bronze" : "text-bronze"}`}>
      {number}
    </span>
    <span className={`h-px w-12 ${dark ? "bg-bronze/60" : "bg-bronze"}`} />
    <span className={`eyebrow ${dark ? "text-bronze" : ""}`}>{label}</span>
  </div>
);
